import React from 'react';
import {
  Box,
  Typography,
  Modal,
  IconButton,
  Divider,
  Button,
  Chip,
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

const StyledChip = styled(Chip)(({ theme, status }) => ({
  backgroundColor: status === "FAILED" 
    ? "#ffebee" 
    : status === "MANUAL"
    ? "#e3f2fd"
    : "#e8f5e9",
  color: status === "FAILED" 
    ? "#d32f2f" 
    : status === "MANUAL"
    ? "#1976d2"
    : "#2e7d32",
  fontWeight: 600,
  fontSize: "0.75rem",
  height: 24,
  "& .MuiChip-label": {
    padding: "0 8px",
  },
}));

const RelatedControlsModal = ({ open, onClose, controls = [], resourceArn }) => {
  const columns = [
    {
      field: 'ControlId',
      headerName: 'Control ID',
      width: 200,
      headerAlign: 'center',
      align: 'center',
    },
    {
      field: 'Status',
      headerName: 'Status',
      width: 150,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) => (
        <StyledChip
          label={params.value}
          status={params.value}
          size="small"
        />
      ),
    },
  ];

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="related-controls-modal"
      aria-describedby="modal-for-viewing-related-controls"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          maxWidth: 900,
          maxHeight: '90vh',
          overflow: 'auto',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 24,
          p: 0,
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            backgroundColor: '#F5F5F5',
            padding: '16px 24px',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
            borderBottom: '1px solid #E0E0E0',
          }}
        >
          <Typography variant="h6" fontWeight="bold">
            Related Controls for {resourceArn}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        {/* DataGrid */}
        <Box sx={{ p: 2 }}>
          <DataGrid
            rows={controls.map((control, index) => ({ id: index, ...control }))}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5, 10, 20, 100]}
            disableSelectionOnClick
            autoHeight
            sx={{
              '& .MuiDataGrid-cell': {
                cursor: 'default',
              },
              '& .MuiDataGrid-row:hover': {
                backgroundColor: '#f5f5f5',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#F5F5F5',
                fontWeight: 'bold',
                fontSize: '14px',
                color: '#333',
              },
              '& .MuiDataGrid-cell': {
                fontSize: '14px',
                fontFamily: "inherit",
              },
            }}
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default RelatedControlsModal; 